import React from "react";
import { Outlet } from "react-router-dom";
import { USPositionProvider } from "../../contexts/USPositionProvider";
import { USUndoProvider } from "../../contexts/USUndoProvider";
import { useLocation } from "react-router-dom";

const PositionsOutlet = () => {
  const location = useLocation();
  return (
    <>
      {/* <USPositionProvider>
        <USUndoProvider> */}
      <Outlet key={location.pathname} />
      {/* </USUndoProvider>
      </USPositionProvider> */}
    </>
  );
};

export default PositionsOutlet;
